<!-- AI Chat Widget Template - Arabic/English Support -->

<!-- Floating chat button -->
<button class="chat-toggle" (click)="toggleChat()" [class.open]="isOpen" title="AI Assistant">
    <span class="icon" *ngIf="!isOpen">💬</span>
    <span class="icon" *ngIf="isOpen">✕</span>
</button>

<!-- Chat container -->
<div class="chat-container" *ngIf="isOpen" @fadeSlide [class.rtl]="isRtl" [attr.dir]="isRtl ? 'rtl' : 'ltr'">
    <!-- Header -->
    <div class="chat-header">
        <div class="avatar">
            <span class="bot-icon">🤖</span>
        </div>
        <div class="header-info">
            <h3>{{ uiText.title }}</h3>
            <span class="status" [class.online]="isConnected">
                {{ isConnected ? uiText.online : uiText.connecting }}
            </span>
        </div>
        <div class="header-actions">
            <button class="action-btn" (click)="newConversation()" [title]="uiText.newConversation">
                <span>🔄</span>
            </button>
            <button class="action-btn" (click)="toggleChat()" [title]="uiText.close">
                <span>✕</span>
            </button>
        </div>
    </div>

    <!-- Messages area -->
    <div class="messages-container" #messagesContainer>
        <!-- Welcome message if no messages -->
        <div class="welcome" *ngIf="messages.length === 0">
            <div class="welcome-icon">👋</div>
            <h4>{{ uiText.welcomeGreeting }}</h4>
            <p>{{ uiText.welcomeDescription }}</p>

            <!-- Quick questions -->
            <div class="quick-questions">
                <p class="quick-label">{{ uiText.quickLabel }}</p>
                <button *ngFor="let q of quickQuestions" class="quick-btn" (click)="sendQuickQuestion(q)">
                    {{ q }}
                </button>
            </div>
        </div>

        <!-- Messages -->
        <div *ngFor="let msg of messages" class="message" [class.user]="msg.role === 'user'"
            [class.assistant]="msg.role === 'assistant'" [class.streaming]="msg.isStreaming">

            <div class="message-avatar">
                <span *ngIf="msg.role === 'user'">👤</span>
                <span *ngIf="msg.role === 'assistant'">🤖</span>
            </div>

            <div class="message-content">
                <div class="content-text" [innerHTML]="formatMessage(msg.content)">
                </div>
                <span class="cursor" *ngIf="msg.isStreaming">▌</span>
                <span class="time">
                    {{ msg.timestamp | date:'shortTime' }}
                </span>
            </div>
        </div>

        <!-- Typing indicator -->
        <div class="typing-indicator" *ngIf="isTyping">
            <div class="message-avatar">
                <span>🤖</span>
            </div>
            <div class="dots">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </div>

    <!-- Input area -->
    <div class="input-container">
        <input type="text" [(ngModel)]="inputMessage" (keydown.enter)="sendMessage()"
            [placeholder]="isRecording ? uiText.listeningPlaceholder : uiText.inputPlaceholder"
            [disabled]="isTyping || !isConnected || isRecording" class="message-input" />

        <button class="voice-btn" (click)="toggleRecording()" [class.recording]="isRecording"
            [class.processing]="isProcessingVoice"
            [disabled]="isTyping || !isConnected || isProcessingVoice" [title]="uiText.voiceChat">
            <span>{{ isProcessingVoice ? '⏳' : isRecording ? '⏹' : '🎤' }}</span>
        </button>

        <button class="send-btn" (click)="sendMessage()"
            [disabled]="!inputMessage.trim() || isTyping || !isConnected || isRecording">
            <span>➤</span>
        </button>
    </div>
</div>